/** @file frameView: points the viewport camera at a joint (F, the tree's Frame), or home without one. */
import { poseNode } from './poseNode';
import type { ViewportCtx } from './viewportCtx';

/** Looks at joint `name` as the puppet draws it now; home when `name` is undefined or not a drawn joint. */
export function frameView(ctx: ViewportCtx, name: string | undefined): void {
  const p = ctx.puppet();
  const i = name === undefined || p === null ? -1 : p.names.indexOf(name);
  if (p === null || i < 0) { ctx.camera?.home(); return; }
  ctx.camera?.lookAt(poseNode(p.instance.state().pose, i).pos);
}
